import {FC, useCallback, useEffect, useState} from 'react'
import {numberWithCommas} from '../../../../../../_metronic/helpers'
import {ProductServiceOnlinePrice} from '../core/_models'
import {getOnlineProductServicePrices} from '../core/_requests'

type Props = {
  priceSourceType: number
  title?: string
}

const OnlinePriceHistoryTable: FC<Props> = ({priceSourceType, title = 'قیمت‌های آنلاین'}) => {
  const [prices, setPrices] = useState<ProductServiceOnlinePrice[]>([])
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState<string | undefined>()

  const loadPrices = useCallback(async () => {
    if (priceSourceType <= 1) {
      setPrices([])
      return
    }

    try {
      setLoading(true)
      setMessage(undefined)
      const data = await getOnlineProductServicePrices(priceSourceType, 30)
      setPrices(data)
    } catch (error: any) {
      setMessage(error?.response?.data?.Message || error?.message || 'خطا در دریافت قیمت آنلاین')
    } finally {
      setLoading(false)
    }
  }, [priceSourceType])

  useEffect(() => {
    loadPrices()
  }, [loadPrices])

  return (
    <div className='mp-price-history mp-online-price-history mt-8'>
      <div className='d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4'>
        <div>
          <h4 className='fw-bolder mb-1'>{title}</h4>
          <span className='text-gray-500 fs-7'>
            این جدول از قیمت‌های ذخیره‌شده سرویس آنلاین خوانده می‌شود و قابل ویرایش دستی نیست.
          </span>
        </div>
        <button
          type='button'
          className='btn btn-sm btn-icon btn-light'
          disabled={loading}
          onClick={loadPrices}
          title='بروزرسانی'
        >
          <i className='las la-sync fs-2' />
        </button>
      </div>

      {message && <div className='alert alert-danger py-3'>{message}</div>}
      <div className='alert alert-info py-3'>
        برای تغییر این قیمت‌ها باید منبع آنلاین بروزرسانی شود؛ در این بخش دکمه ویرایش و حذف وجود
        ندارد.
      </div>

      <div className='mp-catalog-scroll-hint mt-5'>
        <i className='las la-arrows-alt-h fs-2' aria-hidden='true'></i>
        برای مشاهده همه ستون‌ها، جدول را به طرفین بکشید.
      </div>
      <div className='table-responsive mp-price-table mt-2'>
        <table className='table align-middle table-row-dashed fs-6 gy-4'>
          <thead>
            <tr className='text-muted fw-bolder fs-7'>
              <th>تاریخ دریافت</th>
              <th>پروفایل منبع</th>
              <th className='text-end'>قیمت</th>
              <th className='text-end'>آخرین بررسی</th>
              <th className='text-center'>تعداد بررسی</th>
            </tr>
          </thead>
          <tbody className='text-gray-700 fw-bold'>
            {prices.length === 0 && (
              <tr>
                <td colSpan={5} className='text-center text-gray-500 py-8'>
                  {loading ? 'در حال دریافت قیمت‌ها...' : 'قیمتی برای این سرویس ذخیره نشده است'}
                </td>
              </tr>
            )}
            {prices.map((item) => (
              <tr key={`${item.id}`}>
                <td>{item.fdt || '-'}</td>
                <td>
                  <div className='d-flex flex-column'>
                    <span className='fw-bolder text-gray-900'>{item.spf || '-'}</span>
                    <span className='text-gray-500 fs-8'>{item.spv || '-'}</span>
                  </div>
                </td>
                <td className='text-end fw-bolder text-gray-900'>
                  {numberWithCommas(item.pr?.toString() || '')}
                </td>
                <td className='text-end'>{item.lca || '-'}</td>
                <td className='text-center'>
                  <span className='badge badge-light-primary'>{item.cc || 0}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export {OnlinePriceHistoryTable}
